import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, Row, Button } from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  TextInput,
  CheckboxInput,
} from "App/components/Inputs/BasicFormInputs.js";
const _ = require("lodash");

const ListModal = ({
  edit = false,
  clone = false,
  visible = false,
  setVisible,
  list = {},
  addList,
  editList,
  cloneList,
  loading,
}) => {
  return (
    <Modal
      className="modal-dialog-centered formModal"
      isOpen={visible}
      data-testid="modal"
      backdrop="static"
    >
      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <div className="spinner-border">
            <span className="sr-only">loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="modal-header">
            <h2 className="modal-title">
              {edit ? "Edit" : clone ? "Clone" : "Add"} List
            </h2>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setVisible(false)}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <Formik
            enableReinitialize={true}
            initialValues={{
              name: list?.name || "",
              isActive: list?.isActive === undefined ? true : list?.isActive,
            }}
            validationSchema={Yup.object({
              name: Yup.string()
                .required("Required")
                .max(200, "Cannot be longer than 200 characters"),
              isActive: Yup.boolean(),
            })}
            onSubmit={(values, { setSubmitting }) => {
              let newValues = {
                ...values,
              };
              //Convert all "" to null values
              newValues = _.transform(
                newValues,
                (result, value, key) =>
                  (result[key] = value === "" ? null : value),
              );

              if (edit) {
                editList({ id: list.id, ...newValues });
              } else if (clone) {
                cloneList({ id: list.id, ...newValues });
              } else {
                addList(newValues);
              }
            }}
          >
            {formikProps => {
              return (
                <>
                  <ModalBody>
                    <Form>
                      <Row>
                        <TextInput label="Name" name="name" col={12} />
                      </Row>
                      <Row>
                        <CheckboxInput
                          col={6}
                          enablevalidation={false}
                          name="isActive"
                        >
                          Active
                        </CheckboxInput>
                      </Row>
                    </Form>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      onClick={formikProps.submitForm}
                      color="primary"
                      type="submit"
                      data-testid="submitbutton"
                    >
                      {edit ? "Edit" : clone ? "Clone" : "Add"} List
                    </Button>
                  </ModalFooter>
                </>
              );
            }}
          </Formik>
        </>
      )}
    </Modal>
  );
};

ListModal.propTypes = {
  edit: PropTypes.bool,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  list: PropTypes.object,
  addList: PropTypes.func,
  editList: PropTypes.func,
  loading: PropTypes.bool,
};

export default ListModal;
